'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _abTests = require('../../../config/abTests');

var _MyLinkBox = require('./MyLinkBox');

var _MyLinkBox2 = _interopRequireDefault(_MyLinkBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var customLinkBox = function customLinkBox(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      redimension = _useState2[0],
      setRedimension = _useState2[1];

  (0, _react.useEffect)(function () {
    setRedimension((0, _abTests.isCentralHeaderMenuEnabled)());
  }, []);

  return _react2.default.createElement(_MyLinkBox2.default, (0, _extends3.default)({}, props, { redimension: redimension }));
};

exports.default = customLinkBox;